import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {PlaceOfApplication} from './place-of-application';
import {PlacesOfApplicationService} from '../places-of-application.service';
import {Results} from '../../../core/results';
declare var $: any;
@Directive({
  selector: '[appPlaceOfApplication]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PlaceOfApplicationDirective),
    multi: true
  }]
})
export class PlaceOfApplicationDirective implements ControlValueAccessor, OnInit {

  @Input() private placeOfApplication: PlaceOfApplication;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: PlacesOfApplicationService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Where are you applying from',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<PlaceOfApplication>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.placeOfApplication = JSON.parse(e.params.data.id);
      that.propagateChange(that.placeOfApplication);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.placeOfApplication = null;
      that.propagateChange(that.placeOfApplication);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(placeOfApplication: PlaceOfApplication): void {

    this.placeOfApplication = placeOfApplication;
    this.propagateChange(this.placeOfApplication);
    const that = this;
    if (this.placeOfApplication !== undefined && this.placeOfApplication !== null) {
      const option = new Option(placeOfApplication.name, JSON.stringify(placeOfApplication), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.placeOfApplication;
  }

  set value(v: any) {
    if (v !== this.placeOfApplication) {
      this.placeOfApplication = v;
      this.propagateChange(v);
    }
  }

}
